/*
Replace
resourceName with your resource Name :) Take care about different writings!
/!\ Analytic analytic Analytics analytics /!\
Keep an eye on pluralized namings in here :)
*/

import { createSlice, createSelector } from "@reduxjs/toolkit";
import {
  defaultShow,
  defaultShowFail,
  defaultShowSuccess,
  defaultAddToDictionary,
  defaultRemove,
  defaultRemoveSuccess,
  defaultRemoveFail,
  defaultRemoveReset,
} from "../defaultReducers";
import { defaultInitialState } from "../defaultInitialState";
import Cookies from "universal-cookie";
const cookieHandler = new Cookies();

export const analyticsSlice = createSlice({
  name: "analytics",
  initialState: { ...defaultInitialState, showMeta: null },
  reducers: {
    show: defaultShow,
    showSuccess: (state, action) => {
      state.loadingShow = false;
      state.loadedShow = true;
      state.show = action.payload?.obj?.data;
      state.showId = action.payload?.obj?.data?.id;
      state.dictionary[action.payload?.obj?.data?.id] =
        action.payload?.obj?.data;
      state.showMeta = action.payload.obj.meta;
    },
    showFail: defaultShowFail,
    addToDictionary: defaultAddToDictionary,
    showErrorReset: (state, action) => {
      state.showing = false;
      state.showed = false;
      state.showError = null;
    },
    remove: defaultRemove,
    removeSuccess: defaultRemoveSuccess,
    removeFail: defaultRemoveFail,
    removeReset: defaultRemoveReset,
  },
});

export const { show: showAnalytic } = analyticsSlice.actions;

export const actions = analyticsSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.counter.value)`
export const analytics = (state) =>
  state.analytics.idsList.map((id) => state.analytics.dictionary[id]);
export const analytic = (state) =>
  state.analytics.showId && state.analytics.dictionary[state.analytics.showId];
export const analyticAttributes = (state) => analytic(state)?.attributes;
export const analyticRelationships = (state) => analytic(state)?.relationships;
export const analyticId = (state) => state.analytics.showId;
export const currentAnalyticId = (state) => state.analytics.currentAnalyticId;

export const getAnalytic = createSelector(
  (state) => state.analytics.dictionary,
  (_, id) => id,
  (dictionary, id) => {
    return id && dictionary && dictionary[id];
  }
);

export const getAnalyticAttributes = createSelector(
  (state) => state.analytics.dictionary,
  (_, id) => id,
  (dictionary, id) => {
    return id && dictionary && dictionary[id]?.attributes;
  }
);

export const getAnalyticRelationships = createSelector(
  (state) => state.analytics.dictionary,
  (_, id) => id,
  (dictionary, id) => {
    return id && dictionary && dictionary[id]?.relationships;
  }
);

export const getAnalytics = createSelector(
  (state) => state.analytics.dictionary,
  (_, ids) => ids,
  (dictionary, ids) => {
    return ids && dictionary && ids.map((id) => dictionary[id]);
  }
);

export default analyticsSlice.reducer;
